function updateCartCount() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      document
        .querySelectorAll('.js-cart-count')
        .forEach(el => {
          el.textContent = cart.item_count;
        });
    });
}
document.addEventListener('cart:updated', updateCartCount);
document.addEventListener('cart:refresh', updateCartCount);



document.addEventListener("DOMContentLoaded", function () {
  const newsletterForms = document.querySelectorAll('#t4s-form-newsletter, #contact_form');
  const footerContactForms = document.querySelectorAll('[data-footer-contact-form]');

  newsletterForms.forEach(form => {
    form.addEventListener("submit", function () {
      sessionStorage.setItem("newsletter_scroll", window.scrollY);
    });
  });

  const setFooterSubmitting = (form, loading) => {
    const submitButton = form.querySelector('[data-footer-contact-submit]');
    if (!submitButton) return;
    submitButton.classList.toggle('is-submitting', loading);
    submitButton.toggleAttribute('disabled', loading);
  };

  const autoHideFooterSuccess = (form, delay = 4000) => {
    const successFeedback = form.querySelector('.footer-form-feedback--success');
    if (!successFeedback) return;

    window.setTimeout(() => {
      if (successFeedback.parentNode) {
        successFeedback.parentNode.removeChild(successFeedback);
      }
    }, delay);
  };

  const wireCaptcha = (form) => {
    if (!window.Shopify || !window.Shopify.captcha || typeof window.Shopify.captcha.protect !== 'function') {
      return;
    }
    window.Shopify.captcha.protect(form);
  };

  footerContactForms.forEach((form) => {
    const checkbox = form.querySelector('.custom-checkbox');
    const wrapper = form.querySelector('.custom-checkbox-wrapper'); 
    const validationMessage = form.dataset.validationMessage || 'Bitte bestätigen Sie die Datenschutzbestimmungen und AGB.';

    if (checkbox) {
      checkbox.setAttribute('data-checked', 'true');
      checkbox.classList.remove('unchecked');
    }

    if (checkbox && wrapper) {
      wrapper.addEventListener('click', function () {
        const isChecked = checkbox.getAttribute('data-checked') === 'true';
        checkbox.setAttribute('data-checked', isChecked ? 'false' : 'true');
        checkbox.classList.toggle('unchecked', isChecked);
      });
    }

    wireCaptcha(form);
    autoHideFooterSuccess(form);

    form.addEventListener('submit', function (e) {
      const isChecked = !checkbox || checkbox.getAttribute('data-checked') === 'true';
      if (!isChecked) {
        e.preventDefault();
        alert(validationMessage);
        return;
      }
      setFooterSubmitting(form, true);
    });
  });

  const urlParams = new URLSearchParams(window.location.search);
  const isSuccess = urlParams.get("customer_posted");
  const isContactSuccess = urlParams.get("contact_posted");

  if (isSuccess === "true") {
    const scrollPos = sessionStorage.getItem("newsletter_scroll");

    if (scrollPos) {
      setTimeout(() => {
        window.scrollTo({
          top: parseInt(scrollPos),
          behavior: "instant"
        });
      }, 80);

      sessionStorage.removeItem("newsletter_scroll");
    }

    setTimeout(() => {
      const modal = document.getElementById("newsletter-thankyou-modal");
      if (modal) modal.classList.add("is-open");
    }, 120);

    window.history.replaceState({}, document.title, window.location.pathname);
  }

  if (isContactSuccess === "true") {
    setTimeout(() => {
      const modal = document.getElementById("footer-contact-thankyou-modal");
      if (!modal) return;
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");

      // 有成功图片时不自动关闭；无图片时文字提示 4 秒后关闭
      if (!modal.classList.contains("footer-contact-thankyou-modal--image")) {
        setTimeout(() => {
          modal.classList.remove("is-open");
          modal.setAttribute("aria-hidden", "true");
        }, 4000);
      }
    }, 280);

    window.history.replaceState({}, document.title, window.location.pathname);
  } else if (document.querySelector('[data-footer-contact-form] .footer-form-feedback--success')) {
    setTimeout(() => {
      const modal = document.getElementById("footer-contact-thankyou-modal");
      if (!modal) return;
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
    }, 280);
  }

  document.addEventListener("click", function (e) {
    if (e.target.classList.contains("newsletter-thankyou-modal__close")) {
      const modal = e.target.closest(".newsletter-thankyou-modal");
      if (modal) {
        modal.classList.remove("is-open");
        modal.setAttribute("aria-hidden", "true");
      }
      return;
    }

    if (e.target.classList.contains("newsletter-thankyou-modal")) {
      e.target.classList.remove("is-open");
      e.target.setAttribute("aria-hidden", "true");
    }
  });

  /* size-guide-popup */
  const openSizeGuide = () => {
    const popup = document.querySelector("[data-size-guide-popup]");
    if (!popup) return;
    popup.classList.add("is-open");
    popup.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("size-guide-popup-open");
  };
  const closeSizeGuide = () => {
    document.querySelectorAll("[data-size-guide-popup].is-open").forEach((popup) => {
      popup.classList.remove("is-open");
      popup.setAttribute("aria-hidden", "true");
    });
    document.documentElement.classList.remove("size-guide-popup-open");
  };

  document.addEventListener("click", function (e) {
    const openBtn = e.target.closest("[data-size-guide-open]");
    if (openBtn) {
      e.preventDefault();
      openSizeGuide();
      return;
    }
    if (e.target.closest("[data-size-guide-close]")) {
      closeSizeGuide();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeSizeGuide();
  });
  /* end size-guide-popup */

});
